<template>
	 <v-navigation-drawer
		location="right"
		width="1024"
		temporary
		:class="['mobile-drawer-container-right', 'contain-scroll']"
		:scrim="false"
		touchless
		disable-route-watcher
	 	v-model="openState">
	 	<template v-if="contentComponent">

	 		<v-btn
	 			icon size="small"
				:class="['elevation-0', 'close-btn-right']"
				color="primary"
	 			@click="closeMobileDrawerRight">
	 			<v-icon size="28">close</v-icon>
	 		</v-btn>
			<component class="component-container" :is="contentComponent"/>

		</template>
		<template v-else>
			Loading...
		</template>
	 </v-navigation-drawer>
</template>


<script>
	import { markRaw } from 'vue'
	import { mapState, mapActions } from 'vuex'

	import { VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT } from '@/store/constants/ui'

	export default {
		name: 'mobile-drawer-container',

		data: () => ({
			contentComponent: null,
		}),

		computed: {
			...mapState({
				content: state => state.ui.mobileDrawerRight.content
			}),

			openState: {
				get() { return this.$store.state.ui.mobileDrawerRight.openState },
				set() { }
			}
		},

		created() {
			this.loadContent()
		},

		methods: {
			...mapActions({
				closeMobileDrawerRight: VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT
			}),

			loadContent() {
				const loaded = this.content ? this.$root.loadComponent(this.content) : null
				this.contentComponent = loaded ? markRaw(loaded) : null
			},
		},

		watch: {
			content: {
				deep: true,
				handler() {
					this.loadContent()
				}
			}
		}
	}
</script>